import React, { PropsWithChildren } from 'react'
import { Box, DataListItem } from '@node-space/ui-components'
import { ConfirmCustomerDetail } from '../helpers/types'

interface CustomerDetailsSectionProps {
  title?: string
  customerDetails: ConfirmCustomerDetail[]
}

export const CustomerDetailsSection = ({ title, customerDetails }: CustomerDetailsSectionProps) => {
  return (
    <Box>
      {title && <h3 className="text-h3 text-foreground-prominent">{title}</h3>}
      {customerDetails
        ?.filter(({ value = '' }) => !!value)
        ?.map(({ label, value }) => (
          <DataListItem id={label} key={label} title={label} body={value} />
        ))}
    </Box>
  )
}

export const CustomerDetailsWrapper = ({ children }: PropsWithChildren) => {
  return (
    <Box flexCol gapY={16}>
      {children}
    </Box>
  )
}
